import React from 'react';
import IconComponent from 'ui/src/components/Icon';

interface Props {
  onClick: () => void;
  title: string;
}

export default function AccordionTitle({ onClick, title }: Props) {
  return (
    <button type="button" className="site-paragraph-s mdS:hidden flex items-center gap-2 py-2.5" onClick={onClick}>
      <span>{title}</span>
      <IconComponent iconName="ExpandMore" className="bg-current" />
    </button>
  );
}
